import { IClinicStore } from './types';

const initStore: IClinicStore = {
  current: null,
  list: [],
  pagination: {
    pageSize: 25,
    pageNumber: 1,
    total: 0,
  },
};

export default initStore;
